export function cleanHTTPParams<T extends object>(obj: T): Record<string, string | number | boolean> {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([, v]) => v !== null && v !== undefined && v !== '')
  ) as Record<string, string | number | boolean>;
}

export const MAX_FILE_SIZE = 10 * 1024 * 1024;
